type ResultType = string;
type ApiResponseType = ApiSchema['PlaceResponse'];
type ParamsType = object;

/**
 * Loads the place name for a given place ID
 */
export default async function apiLoadPlaceName(placeId: string): Promise<ApiResult<ResultType>> {
    try {
        return await callApiGet<ResultType, ApiResponseType, ParamsType>(
            `/places/${placeId}`,
            {},

            // Transform result
            (response: ApiResponseType): ResultType => {
                // DSI has told us that they'll always return a single StopPlace object only
                return response.places[0]?.name ?? '';
            },
        );
    }
    catch (error) {
        throw new Error('Failed to load place name', { cause: error });
    }
}
